import React from 'react'

import classNames from 'classnames'
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon'
import InformationLineIcon from 'remixicon-react/InformationLineIcon'
import styled from 'styled-components'

import {styledTheme} from '@festi/common/themes'

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-height: 36px;
  padding: 8px;
  border-radius: 8px;

  &.large {
    padding: 20px;
    min-height: 60px;
  }

  &.info {
    background-color: ${styledTheme.palette.lightBlue50};
  }

  &.error {
    background-color: ${styledTheme.palette.pink15};
  }

  &.warning {
    background-color: ${styledTheme.palette.yellow50};
  }

  &.neutral {
    background-color: ${styledTheme.palette.ui4Solid};
  }
`

const IconWrapper = styled.div`
  flex-shrink: 0;
  padding-top: 2px;

  &.large {
    padding-top: 0;
  }
`

const Info = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  &.subtle {
    color: ${styledTheme.palette.ui60Solid};
    font-weight: 400;
  }
`

const iconColorMap = {
  info: styledTheme.palette.lightBlue,
  error: styledTheme.palette.error,
  warning: styledTheme.palette.warning,
  neutral: styledTheme.palette.ui40Solid,
}

interface Props {
  info: string
  variant?: 'info' | 'error' | 'warning' | 'neutral'
  large?: boolean
  subtleText?: boolean
}

export default function InfoBox({
  info,
  variant = 'info',
  large = false,
  subtleText = false,
}: Props) {
  return (
    <Root className={classNames(variant, {large})}>
      <IconWrapper className={classNames({large})}>
        {variant === 'neutral' ? (
          <InformationLineIcon
            color={iconColorMap[variant]}
            size={large ? 20 : 16}
          />
        ) : (
          <ErrorWarningFillIcon
            color={iconColorMap[variant]}
            size={large ? 20 : 16}
          />
        )}
      </IconWrapper>
      <Info className={classNames({subtle: subtleText})}>{info}</Info>
    </Root>
  )
}
